function o(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
export {
  o as getDefaultExportFromCjs
};
//# sourceMappingURL=index.es167.js.map
